import React from 'react';
import PropTypes from 'prop-types';
import {connect} from 'react-redux';
import {Field, reduxForm, getFormValues, getFormSyncWarnings} from 'redux-form';

import {withStyles} from '@material-ui/core/styles';
import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';
import InfoOutlined from '@material-ui/icons/InfoOutlined';
import SaveAltIcon from '@material-ui/icons/SaveAlt';

import {changeDateFormatter,
  getCodeFromGeneralPurposeMap, getErrorCode, API_CODE,
  dntNoFormat, senroNameFormat, getResponseResult, getChargeableCategoryOfKyogaType} from '../../../../../../common/common.js';
import {checkFileNameLength, checkFileSizeZero,
  checkSameName} from '../../../../../../common/fileOperations.js';
import {authOperations} from '../../../../../../reducks/auth';
import {commonOperations} from '../../../../../../reducks/common';
import {attachorderOperations} from '../../../../../../reducks/attachorder';
import {createSearchList} from '../../../../../../common/ComboParts.js';
import MainContainer from '../../../../../organisms/MainContainer.js';
import PaperPart from '../../../../../atoms/PaperPart.js';
import MuiTooltip from '../../../../../atoms/MuiTooltip.js';
import {renderTextField, renderSelect} from '../../../../../atoms/CustomPart.js';
import PositiveButton from '../../../../../atoms/Buttons/PositiveButton.js';
import BackButton from '../../../../../atoms/Buttons/BackButton.js';
import Required from '../../../../../atoms/RequiredMark.js';
import Upload from '../../../../../organisms/UploadCustom';
import * as validateRule from '../../../../../validateRule.js';
import SelectPoleNo from '../../../../../organisms/SelectPoleNo.js';
import {orderBasicFields, mainContractDntInfo} from '../../../../../../common/SFFields';
import WarningMessageArea from '../../../../../molecules/WarningMessageArea.js';

const styles = (theme) => ({
  root: {
    display: 'flex',
    flexDirection: 'column',
  },
  fields: {
    margin: '0px 10px 15px 10px',
  },
  textFieldDate: {
    margin: '0px 10px 15px 10px',
  },
});

/** この画面で登録/更新を行うフィールド名 */
const addParams = {
  OrderKyogaZgsya__c: null, // 申込共架事業者 更新しない
  KoziTitle__c: null, // 工事件名
  Dsp_KoziPlaceMainDntNo__c: null, // 表示用 代表電柱番号
  KoziPlaceMainDntNo_SenroCode__c: null, // 代表電柱_線路コード
  KoziPlaceMainDntNo_SenroName__c: null, // 代表電柱_線路名
  KoziPlaceMainDntNo__c: null, // 代表電柱番号
  KoziPlacePrefectures__c: null, // 都道府県
  KoziPlaceMunicipalities__c: null, // 市区町村
  KoziPlacePlace__c: null, // 場所
  StbType__c: null, // 設備種別 更新しない
  KyogaType__c: null, // 共架種別
  ZizenNegotiationNo__c: null, // 事前協議番号
  MemoContents__c: null, // メモ内容
  OrderCategory__c: null, // 申込区分 更新しない
  OrderStatus__c: null, // 申込ステータス 更新しない
  NWZgsyo__c: null, // 中電NW事業所(汎用マスタのId) 代表電柱番号の中電NW事業所と同じ値を設定する
  MainDntNoNWZgsyo__c: null, // 代表電柱番号の中電NW事業所(汎用マスタのId)
  KyogaZgsya__c: null, // 共架事業者(AccountのId)
  TemporarilySavedDate__c: null, // 一時保存日
};
const updateParams = {
  KoziTitle__c: null, // 工事件名
  Dsp_KoziPlaceMainDntNo__c: null, // 表示用 代表電柱番号
  KoziPlaceMainDntNo_SenroCode__c: null, // 代表電柱_線路コード
  KoziPlaceMainDntNo_SenroName__c: null, // 代表電柱_線路名
  KoziPlaceMainDntNo__c: null, // 代表電柱番号
  KoziPlacePrefectures__c: null, // 都道府県
  KoziPlaceMunicipalities__c: null, // 市区町村
  KoziPlacePlace__c: null, // 場所
  KyogaType__c: null, // 共架種別
  ZizenNegotiationNo__c: null, // 事前協議番号
  MemoContents__c: null, // メモ内容
  NWZgsyo__c: null, // 中電NW事業所(汎用マスタのId) 代表電柱番号の中電NW事業所と同じ値を設定する
  MainDntNoNWZgsyo__c: null, // 代表電柱番号の中電NW事業所(汎用マスタのId)
  TemporarilySavedDate__c: null, // 一時保存日
};

/**
 * 可否判定申込基本情報
 * 画面ID:1002
 */
class Container extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      rootFiles: [],
      horizonFiles: [],
      specFiles: [],
      otherFiles: [],
      pictureFiles: [],
      rootDelFiles: [],
      horizonDelFiles: [],
      specDelFiles: [],
      otherDelFiles: [],
      pictureDelFiles: [],
      isDisabled: true,
      modalOpen: false,
      isModified: false,
      warningMessages: [],
    };
    // 代表電柱情報
    this.MainDnt = {};

    // 線設備と点設備の画面項目を切り替えるフラグ初期化。true:線設備、false:点設備
    this.isSen = this.props.stbType == '1' ? true : false;
  }

  /**
   * 初期処理
   */
  async componentDidMount() {
    try {
      if (this.props.orderId) {
        await this.searchData(true);
      } else {
        // 新規
        this.setState({
          isDisabled: false,
          isModified: false,
          warningMessages: [],
        });
      }
      this.MainDnt = {};
    } catch (error) {
      this.props.doShowMessage({
        message: 'CS0001',
        action: () => {
          this.props.history.push('/login');
        },
      });
    }
  }

  /**
   * 終了処理
   */
  async componentWillUnmount() {
    this.props.doClearOrderInfo();
  }

  /**
   * 検索処理
   * @param {bool} isInit true:初期処理,false:初期処理以外
   */
  searchData = async (isInit=false) => {
    const {orderId, generalPurposeMap} = this.props;
    const attachedFileTypeRoot = getCodeFromGeneralPurposeMap(generalPurposeMap, 'AttachedFileTypeA08', 3);
    const attachedFileTypeHorizon = getCodeFromGeneralPurposeMap(generalPurposeMap, 'AttachedFileTypeA02', 3);
    const attachedFileTypeSpec = getCodeFromGeneralPurposeMap(generalPurposeMap, 'AttachedFileTypeA01', 3);
    const attachedFileTypeOther = getCodeFromGeneralPurposeMap(generalPurposeMap, 'AttachedFileTypeA12', 3);
    const attachedFileTypePicture = getCodeFromGeneralPurposeMap(generalPurposeMap, 'AttachedFileTypeA22', 3);
    const orderStatusCreate = getCodeFromGeneralPurposeMap(generalPurposeMap, 'OrderStatus00', 2);

    // 申込情報、添付ファイル取得
    const appConditions = {
      'Id': orderId,
      'OrderCategory__c': getCodeFromGeneralPurposeMap(generalPurposeMap, 'OrderCategory01', 2),
      'RecordType.DeveloperName': 'ProprietyJudgeOrder',
      'attachedFileTypes': [
        attachedFileTypeRoot,
        attachedFileTypeHorizon,
        attachedFileTypeSpec,
        attachedFileTypeOther,
        attachedFileTypePicture,
      ],
    };
    const response =
      await this.props.doGetOrderInfo(appConditions, orderBasicFields);
    const errorCode = getErrorCode(response);
    if (errorCode != API_CODE.SUCCESS) {
      this.props.doShowMessage({
        message: {
          id: 'CE0052',
          values: ['可否判定申込', '取得'],
        },
      });
      return false;
    }

    if (!isInit) {
      // 保存したとき、排他チェックのために申込の最終更新日時を保存する
      this.setLastModifiedDate(response);
    }

    // ファイル種別ごとにわける
    let _rootFiles = [];
    let _horizonFiles = [];
    let _specFiles = [];
    let _otherFiles = [];
    let _pictureFiles = [];
    if (this.props.contentDocuments &&
      this.props.contentDocuments.length > 0) {
      _rootFiles = this.props.contentDocuments.filter(
          (record) =>
            record.AttachedFileType__c == attachedFileTypeRoot);
      _horizonFiles = this.props.contentDocuments.filter(
          (record) =>
            record.AttachedFileType__c == attachedFileTypeHorizon);
      _specFiles = this.props.contentDocuments.filter(
          (record) =>
            record.AttachedFileType__c == attachedFileTypeSpec);
      _otherFiles = this.props.contentDocuments.filter(
          (record) =>
            record.AttachedFileType__c == attachedFileTypeOther);
      _pictureFiles = this.props.contentDocuments.filter(
          (record) =>
            record.AttachedFileType__c == attachedFileTypePicture);
    }

    this.isSen = this.props.stbType == '1' ? true : false;

    // 可否判定申込作成中の場合は入力チェックを行う
    const _warningMessages = [];
    this.inputCheck(this.props.contentDocuments, _warningMessages);

    this.setState({
      rootFiles: _rootFiles,
      horizonFiles: _horizonFiles,
      specFiles: _specFiles,
      otherFiles: _otherFiles,
      pictureFiles: _pictureFiles,
      rootDelFiles: [],
      horizonDelFiles: [],
      specDelFiles: [],
      otherDelFiles: [],
      pictureDelFiles: [],
      isDisabled: this.props.order &&
              this.props.order.OrderStatus__c ==
              orderStatusCreate ? false : true, // 作成中のみ編集可
      isModified: false,
      warningMessages: _warningMessages,
    });
    return true;
  }

  /**
   * ルート図設定
   * @param {object} files
   * @param {object} deleteFiles
   */
  setRootFiles = (files, deleteFiles) => {
    try {
      const _files =[];
      for (const file of files) {
        file['AttachedFileType__c'] = 'A08';
        _files.push(file);
      }
      this.setState({
        rootFiles: _files,
        rootDelFiles: deleteFiles,
        isModified: true,
      });
    } catch (error) {
      this.props.doShowMessage({
        message: 'CS0001',
        action: () => {
          this.props.history.push('/login');
        },
      });
    }
  }

  /**
   * 平面図設定
   * @param {object} files
   * @param {object} deleteFiles
   */
  setHorizonFiles = (files, deleteFiles) => {
    try {
      const _files =[];
      for (const file of files) {
        file['AttachedFileType__c'] = 'A02';
        _files.push(file);
      }
      this.setState({
        horizonFiles: _files,
        horizonDelFiles: deleteFiles,
        isModified: true,
      });
    } catch (error) {
      this.props.doShowMessage({
        message: 'CS0001',
        action: () => {
          this.props.history.push('/login');
        },
      });
    }
  }

  /**
   * 仕様書設定
   * @param {object} files
   * @param {object} deleteFiles
   */
  setSpecFiles = (files, deleteFiles) => {
    try {
      const _files =[];
      for (const file of files) {
        file['AttachedFileType__c'] = 'A01';
        _files.push(file);
      }
      this.setState({
        specFiles: _files,
        specDelFiles: deleteFiles,
        isModified: true,
      });
    } catch (error) {
      this.props.doShowMessage({
        message: 'CS0001',
        action: () => {
          this.props.history.push('/login');
        },
      });
    }
  }

  /**
   * その他資料設定
   * @param {object} files
   * @param {object} deleteFiles
   */
  setOtherFiles = (files, deleteFiles) => {
    try {
      const _files =[];
      for (const file of files) {
        file['AttachedFileType__c'] = 'A12';
        _files.push(file);
      }
      this.setState({
        otherFiles: _files,
        otherDelFiles: deleteFiles,
        isModified: true,
      });
    } catch (error) {
      this.props.doShowMessage({
        message: 'CS0001',
        action: () => {
          this.props.history.push('/login');
        },
      });
    }
  }

  /**
   * 申込写真設定
   * @param {object} files
   * @param {object} deleteFiles
   */
  setPictureFiles = (files, deleteFiles) => {
    try {
      const _files =[];
      for (const file of files) {
        file['AttachedFileType__c'] = 'A22';
        _files.push(file);
      }
      this.setState({
        pictureFiles: _files,
        pictureDelFiles: deleteFiles,
        isModified: true,
      });
    } catch (error) {
      this.props.doShowMessage({
        message: 'CS0001',
        action: () => {
          this.props.history.push('/login');
        },
      });
    }
  }

  /**
   * 電柱選択画面を閉じる
   */
  closeSelectDnt = () => {
    this.setState({modalOpen: false});
  }

  /**
   * 選択した電柱情報を取得
   * @param {object} dnt
   */
  setSelectedDnt = async (dnt) => {
    try {
      const {change, generalPurposeMap} = this.props;
      const selectedDnt = dnt && dnt.length > 0 ? dnt[0] : null;
      if (selectedDnt) {
        // フォームに電柱情報設定
        let prefecturesCode = null;
        if (generalPurposeMap.PrefCode) {
          const masterData =
            generalPurposeMap.PrefCode.filter(
                (data) => data.Name ==
                selectedDnt.StbItiPrefectures);
          prefecturesCode =
            masterData.length > 0 ? masterData[0].Code__c : null;
        }
        // 汎用マスタから代表電柱の中電事業所のIdを取得
        let nWZgsyo = null;
        if (generalPurposeMap.NWZgsyo) {
          const masterData = generalPurposeMap.NWZgsyo.filter(
              (data) => data.Code__c ==
              selectedDnt.NWZgsyo__r_Code__c);
          nWZgsyo = masterData.length > 0 ? masterData[0].Id : null;
        }
        change('Dsp_KoziPlaceMainDntNo__c',
            dntNoFormat(
                selectedDnt['SenroCode__c'], selectedDnt['DntNoManualInput__c'],
                selectedDnt['K6KansnNo__c'], selectedDnt['K6Bunk1__c'],
                selectedDnt['K6Bunk2__c'], selectedDnt['K6Bunk3__c'],
                selectedDnt['K22SzbtNo__c'], selectedDnt['K22GatiCategory__c']));
        change('KoziPlaceMainDntNo_SenroCode__c', selectedDnt.SenroCode__c);
        change('KoziPlaceMainDntNo_SenroName__c',
            senroNameFormat(selectedDnt['SenroName__c'], selectedDnt['SenroNameKana__c'], selectedDnt['SenroCode__c']));
        change('KoziPlaceMainDntNo__c', selectedDnt['DntNo__c'] ?
          selectedDnt['DntNo__c'] : selectedDnt['DntNoManualInput__c']);
        change('KoziPlacePrefectures__c', prefecturesCode);
        change('KoziPlaceMunicipalities__c', selectedDnt.StbItiMunicipalities);
        change('MainDntNoNWZgsyo__c', nWZgsyo);

        // 代表電柱登録データを作成
        this.setMainDntInfo(selectedDnt, nWZgsyo);
      }
    } catch (error) {
      this.props.doShowMessage({
        message: 'CS0001',
        action: () => {
          this.props.history.push('/login');
        },
      });
    }
  }

  /**
   * 契約電柱に登録する代表電柱情報作成
   * （共架種別は保存時に設定する）
   * @param {object} dntInfo 電柱選択の戻り値
   * @param {object} nwZgsyo 中電NW事業所（汎用マスタのId）
  */
  setMainDntInfo = (dntInfo, nwZgsyo) => {
    const {userInfo, order, stbType, generalPurposeMap} = this.props;
    const attachTypeNew = getCodeFromGeneralPurposeMap(generalPurposeMap, 'AttachType1', 1);
    this.MainDnt = {};
    Object.assign(this.MainDnt, mainContractDntInfo);
    for (const key in mainContractDntInfo) {
      if (Object.hasOwnProperty.call(dntInfo, key)) {
        this.MainDnt[key] = dntInfo[key];
      }
    }
    this.MainDnt['SerialNumber__c'] = 1;
    this.MainDnt['NWZgsyo__c'] = nwZgsyo;
    this.MainDnt['NWKoziHopeKoziContents__c'] =
      getCodeFromGeneralPurposeMap(generalPurposeMap, 'DrSideKoziKinds01', 2); ;
    if (order &&
      Object.hasOwnProperty.call(order, 'Id') &&
      order.Id) {
      this.MainDnt['StbType__c'] = order.StbType__c;
      this.MainDnt['AttachType__c'] = order.StbType__c == '2' ? attachTypeNew : null;
      this.MainDnt['KyogaZgsya__c'] = order.OrderKyogaZgsya__c;
    } else {
      this.MainDnt['StbType__c'] = stbType;
      this.MainDnt['AttachType__c'] = stbType == '2' ? attachTypeNew : null;
      this.MainDnt['KyogaZgsya__c'] = userInfo.AccountId;
    }
  }

  /**
   * 申込と添付ファイルの登録/更新処理
   */
  insertOrUpdate = async () => {
    const {userInfo, values, order, generalPurposeMap,
      orderModifiedCondition} = this.props;
    const orderStatusCreate = getCodeFromGeneralPurposeMap(generalPurposeMap, 'OrderStatus00', 2);

    // SF削除対象ファイル抽出
    let _rootDelFiles = this.state.rootDelFiles != null ?
      this.state.rootDelFiles : [];
    const deleteFiles = _rootDelFiles
        .concat(this.state.horizonDelFiles)
        .concat(this.state.specDelFiles)
        .concat(this.state.otherDelFiles)
        .concat(this.state.pictureDelFiles);

    const isSetMainDnt = (this.MainDnt &&
        Object.hasOwnProperty.call(this.MainDnt, 'SerialNumber__c') &&
        this.MainDnt['SerialNumber__c'] == 1);
    // 代表電柱情報を設定
    if (isSetMainDnt) {
      this.MainDnt['KyogaType__c'] =
          Object.hasOwnProperty.call(values, 'KyogaType__c') ? values.KyogaType__c : null;

      this._setBillCategory(values, generalPurposeMap, this.MainDnt);
    }

    let resultSave = null;
    if (order &&
        Object.hasOwnProperty.call(order, 'Id') &&
        order.Id) {
      const conditions = {
        Id: order.Id,
        LastModifiedDate: orderModifiedCondition != null ?
          orderModifiedCondition.LastModifiedDate : null,
      };
      const updateData = {Id: order.Id}; // Idは更新キー
      for (const key in updateParams) {
        if (Object.hasOwnProperty.call(values, key) ) {
          updateData[key] = values[key];
        }
      }
      updateData['NWZgsyo__c'] = updateData['MainDntNoNWZgsyo__c'];

      resultSave = await this.props.doSaveProprietyOrder(
          conditions, updateData,
          this.state.rootFiles, this.state.horizonFiles,
          this.state.specFiles, this.state.otherFiles,
          this.state.pictureFiles, deleteFiles,
          (isSetMainDnt ? this.MainDnt : {}));
    } else {
      const insertData = {};
      for (const key in addParams) {
        if (Object.hasOwnProperty.call(values, key)) {
          insertData[key] = values[key];
        }
      }
      insertData['NWZgsyo__c'] = insertData['MainDntNoNWZgsyo__c'];
      insertData['OrderKyogaZgsya__c'] = userInfo.AccountId;
      insertData['KyogaTanto__c'] = userInfo.Id;
      insertData['OrderCategory__c'] =
          generalPurposeMap.OrderCategory
              .filter((data) => data.ExternalId__c == 'OrderCategory01')[0].Code__c; // 可否判定申込
      insertData['OrderStatus__c'] = orderStatusCreate; // 作成中

      resultSave = await this.props.doSaveProprietyOrder(
          null, insertData,
          this.state.rootFiles, this.state.horizonFiles,
          this.state.specFiles, this.state.otherFiles,
          this.state.pictureFiles, deleteFiles,
          (isSetMainDnt ? this.MainDnt : {}));
    }
    const resResult = getResponseResult(resultSave, ['申込', '保存']);
    if (resResult.errorCode != API_CODE.SUCCESS) {
      return resResult;
    }

    let id = null;
    if (Object.hasOwnProperty.call(this.props.orderResult, 'orderId')) {
      id = this.props.orderResult.orderId;
    }
    this.props.doSetOrderId(id);
    this.MainDnt = {};
    return {success: true, messages: resResult.messages};
  }

   /**
    * 可否判定費用請求区分の設定。
    *
    * @param {object} values 入力情報
    * @param {object} generalPurposeMap 汎用マスタ
    * @param {object} target 設定対象データ
    */
   _setBillCategory = (values, generalPurposeMap, target) => {
     // 共架種別が設定されていない場合は何もしない
     if (!values.KyogaType__c) {
       return;
     }

     const billCategory = getChargeableCategoryOfKyogaType(
         generalPurposeMap, values.KyogaType__c);
     target['ProprietyJudgeCostBillCategory__c'] = billCategory;
   }

  /**
   * 保存ボタン押下時
   */
  doSave = async () => {
    try {
      const ret = await this.insertOrUpdate();
      if (!ret.success) {
        if (ret.messages.filter((data) => data.id == 'CE0048').length > 0) {
          this.props.doShowMessage({
            message: ret.messages,
            action: async () => {
              // 排他チェックエラーになったら、データの整合性をとるため一覧へ遷移する
              this.props.history.push(
                  {pathname: '/ProprietyList'},
                  null, this.props.history.option.CLEAR,
              );
            },
          });
        } else {
          this.props.doShowMessage({message: ret.messages});
        }
        return;
      }

      // 契約電柱最大数登録済で代表電柱を追加できなかったら、
      // エラーメッセージを表示する。処理は継続する。
      const _messages = [{
        id: 'CI0010',
        values: ['保存'],
      }];
      if (ret.messages != null && ret.messages.length > 0 &&
        ret.messages[0].id == 'CE0218') {
        _messages.push({
          id: 'CE0218',
          values: ['申込電柱', '30',
          this.props.stbType == '1' ?
          '可否判定申込（申込電柱：線設備）画面' : '可否判定申込（申込電柱：点設備）画面',
          ],
        });
      }

      this.props.doShowMessage({
        message: _messages,
        action: async () => {
          // 画面再描画時のデータを取得する
          await this.searchData();
        },
      });
    } catch (error) {
      this.props.doShowMessage({
        message: 'CS0001',
        action: () => {
          this.props.history.push('/login');
        },
      });
    }
  };

  /**
   * 申込電柱入力ボタン押下時
   */
  doMoveNext = async () => {
    try {
      const {order} = this.props;

      // 申込情報未登録はエラー
      if (order == null || order.Id == null) {
        this.props.doShowMessage({
          message: {
            id: 'CE0169',
            values: ['可否判定申込', '申込電柱'],
          },
        });
        return;
      }

      // 申込ステータスが作成中以外は参照なので、入力チェックしない
      if (order.OrderStatus__c != '00') {
        this.doNext();
        return;
      }

      // 編集ありの場合、ユーザーに確認して次画面へ遷移
      // 編集していても保存しない
      if (this.props.dirty || this.state.isModified) {
        this.props.doShowMessage({
          message: {
            id: 'CW0013',
          },
          action: async () => {
            await this.doCheckInput();
          },
        });
        return;
      } else {
        await this.doCheckInput();
        return;
      }
    } catch (error) {
      this.props.doShowMessage({
        message: 'CS0001',
        action: () => {
          this.props.history.push('/login');
        },
      });
    }
  }

  /**
   * 申込の最終更新日時を保存
   * @param {object} response APIの戻り値
   */
  setLastModifiedDate = async (response) => {
    let orderId = null;
    let lastModifiedDate = null;
    if (response) {
      const data = response.data.body.data ? response.data.body.data : null;
      orderId =
        data && Object.hasOwnProperty.call(data, 'order') &&
        Object.hasOwnProperty.call(data.order, 'Id') ?
        data.order.Id : null;
      lastModifiedDate =
        data && Object.hasOwnProperty.call(data, 'order') &&
        Object.hasOwnProperty.call(data.order, 'LastModifiedDate') ?
        data.order.LastModifiedDate : null;
    }
    await this.props.doSetOrderModifiedCondition(orderId, lastModifiedDate);
  }

  /**
   * 画面遷移時の入力チェック
   * @param {array} attachedFile
   * @param {array} warningMessages {id: message id, values:[]}
   */
  inputCheck = async (attachedFile, warningMessages) => {
    const {order, generalPurposeMap} = this.props;
    const messages = []; // {id: message id, values:[]}

    if (order == null) {
      await this.props.doSetGmnWarning('1002', true);
      return;
    }
    const orderStatusCreate = getCodeFromGeneralPurposeMap(generalPurposeMap, 'OrderStatus00', 2);

    if (order &&
      order.OrderStatus__c != orderStatusCreate) {
      // 作成中のときだけ入力チェックする
      return;
    }

    if (!order.KoziTitle__c) {
      messages.push({
        id: 'CE0017',
        values: ['工事件名'],
      });
    } else {
      if (order.KoziTitle__c.length > 50) {
        messages.push({
          id: 'CE0041',
          values: ['工事件名'],
        });
      }
    }
    if (!order.KoziPlaceMainDntNo__c) {
      messages.push({
        id: 'CE0017',
        values: ['代表電柱番号'],
      });
    }
    if (!order.KoziPlacePrefectures__c) {
      messages.push({
        id: 'CE0017',
        values: ['都道府県'],
      });
    }
    if (!order.KoziPlaceMunicipalities__c) {
      messages.push({
        id: 'CE0017',
        values: ['市区町村'],
      });
    } else {
      if (order.KoziPlaceMunicipalities__c.length > 12) {
        messages.push({
          id: 'CE0041',
          values: ['市区町村'],
        });
      }
    }
    if (!order.KoziPlacePlace__c) {
      messages.push({
        id: 'CE0017',
        values: ['場所'],
      });
    } else {
      if (order.KoziPlacePlace__c.length > 255) {
        messages.push({
          id: 'CE0041',
          values: ['場所'],
        });
      }
    }
    if (!order.KyogaType__c) {
      messages.push({
        id: 'CE0017',
        values: ['共架種別'],
      });
    }
    if (order.ZizenNegotiationNo__c &&
      order.ZizenNegotiationNo__c.length > 13) {
      messages.push({
        id: 'CE0041',
        values: ['協議番号'],
      });
    }
    if (order.MemoContents__c &&
      order.MemoContents__c.length > 255) {
      messages.push({
        id: 'CE0041',
        values: ['メモ内容'],
      });
    }
    // 添付ファイルの必須チェックは行う。
    // 線設備の場合、申込写真、ルート図、共架設備仕様書が必須
    const fileNames = [];
    let contents = attachedFile.filter((data)=>data.AttachedFileType__c == 'A22');
    if (contents.length == 0) {
      fileNames.push('装柱図');
    }
    if (order.StbType__c == '1') {
      contents = attachedFile.filter((data)=>data.AttachedFileType__c == 'A08');
      if (contents.length == 0) {
        fileNames.push('ルート図');
      }
      contents = attachedFile.filter((data)=>data.AttachedFileType__c == 'A01');
      if (contents.length == 0) {
        fileNames.push('共架設備仕様書');
      }
    }
    // 点設備の場合、申込写真、平面図、共架設備仕様書が必須
    if (order.StbType__c == '2') {
      contents = attachedFile.filter((data)=>data.AttachedFileType__c == 'A02');
      if (contents.length == 0) {
        fileNames.push('平面図');
      }
      contents = attachedFile.filter((data)=>data.AttachedFileType__c == 'A01');
      if (contents.length == 0) {
        fileNames.push('共架設備仕様書');
      }
    }
    for (const value of fileNames) {
      warningMessages.push(
          {id: 'CE0018',
            values: [value]},
      );
    }

    let result = (messages.length > 0 || warningMessages.length > 0);
    await this.props.doSetGmnWarning('1002', result);
  }

  /**
   * 画面遷移時の入力チェック
   */
  doCheckInput = async () => {
    let _hasError = false;
    if (this.props.setGmnWarning) {
      if (Object.hasOwnProperty.call(this.props.setGmnWarning, '1002')) {
        _hasError = this.props.setGmnWarning['1002'];
      }
    }

    // 警告表示
    // 入力チェックNG
    if (_hasError) {
      this.props.doShowMessage({
        message: {id: 'CW0157', values: ['申込']},
        action: () => {
          this.doNext();
        },
      });
      return;
    }

    // 入力チェックOK
    this.doNext();
  }

  /**
   * 次画面へ遷移
   */
  doNext = () => {
    if (this.isSen) {
      this.props.history.push({pathname: '/ProprietySenOrderDnt'});
    } else {
      this.props.history.push({pathname: '/ProprietyTenOrderDnt'});
    }
  }

  /**
   * 画面描画
   * @return {*}
   */
  render() {
    const {classes, userInfo, generalPurposeMap, handleSubmit} = this.props;

    const footerBtn = (
      <Grid container
        justifyContent="center"
        alignItems="flex-start"
        spacing={1}
      >
        <Grid key="key1002InputOrderDnt" item>
          <PositiveButton
            id="btn1002InputOrderDnt"
            onClick={handleSubmit(this.doMoveNext)}
            variant="contained"
            size="large"
          >
            <span>申込電柱入力</span>
          </PositiveButton>
        </Grid>
        <Grid key="key1002Save" item>
          <PositiveButton
            id="btn1002Save"
            onClick={handleSubmit(this.doSave)}
            variant="contained"
            size="large"
            startIcon={<SaveAltIcon />}
            disabled={this.state.isDisabled}
          >
            <span>保存</span>
          </PositiveButton>
        </Grid>
        <Grid key="key1002Back" item>
          <BackButton props={this.props}
            isModified={this.state.isModified}
            showWarning={true}/>
        </Grid>
      </Grid>
    );

    return (
      <>
        <form noValidate autoComplete="off" className={classes.root}>
          <MainContainer
            props={this.props}
            footerBtn={footerBtn}>
            <WarningMessageArea messages={this.state.warningMessages}/>
            <Grid
              container
              justifyContent="flex-start"
              alignItems="flex-start"
              spacing={1}>
              {/* 申込情報 */}
              <Grid key="key1002OrderGrid" item xs={12}>
                <PaperPart>
                  <Typography variant="h6" gutterBottom>申込情報</Typography>
                  <Grid
                    container
                    justifyContent="flex-start"
                    alignItems="flex-start"
                    spacing={1}>
                    <Grid key="key1002OrderNo" item xs={12} sm={2}>
                      <Field
                        id="id1002OrderNo"
                        name="OrderNo__c"
                        component={renderTextField}
                        className={classes.fields}
                        label='可否判定申込番号'
                        type="text"
                        fullWidth
                        InputProps={{
                          readOnly: true,
                        }}
                        required={false}
                        validate={[
                        ]}
                      />
                    </Grid>
                    <Grid key="key1002OrderDate" item xs={12} sm={2}>
                      <Field
                        id="id1002OrderDate"
                        name="ProprietyJudgeOrderDate__c"
                        label='可否判定申込年月日'
                        component={renderTextField}
                        className={classes.textFieldDate}
                        fullWidth
                        required={false}
                        type="date"
                        InputLabelProps={{
                          shrink: true,
                        }}
                        InputProps={{
                          readOnly: true,
                        }}
                        validate={[
                        ]}
                      />
                    </Grid>
                    <Grid key="key1002SaveDate" item xs={12} sm={2}>
                      <Field
                        id="id1002SaveDate"
                        name="TemporarilySavedDate__c"
                        label='一時保存日'
                        component={renderTextField}
                        className={classes.textFieldDate}
                        fullWidth
                        required={false}
                        type="date"
                        InputLabelProps={{
                          shrink: true,
                        }}
                        InputProps={{
                          readOnly: true,
                        }}
                        validate={[
                        ]}
                      />
                    </Grid>
                    <Grid key="key1002SendBackReason" item xs={12} sm={4}>
                      <Field
                        id="id1002SendBackReason"
                        name="KyogasyaSendBackReason__c"
                        component={renderTextField}
                        className={classes.fields}
                        label='差戻理由'
                        type="text"
                        fullWidth
                        InputProps={{
                          readOnly: true,
                        }}
                        required={false}
                        validate={[
                        ]}
                      />
                    </Grid>
                  </Grid>
                  {/* 共架者情報 */}
                  <Grid container
                    justifyContent="flex-start"
                    alignItems="flex-start"
                    spacing={1}
                  >
                    <Grid key="key1002OrderKyogaZgsya" item xs={12} sm={5}>
                      {/* 共架事業者＝会社名＋事業所名 */}
                      <Field
                        id="id1002OrderKyogaZgsya"
                        name="OrderKyogaZgsyaName"
                        component={renderTextField}
                        className={classes.fields}
                        label='申込共架事業者'
                        type="text"
                        fullWidth
                        InputLabelProps={{
                          shrink: true,
                        }}
                        InputProps={{
                          readOnly: true,
                        }}
                        required={false}
                        validate={[
                        ]}
                      >
                      </Field>
                    </Grid>
                    <Grid key="key1002KoziTitle" item xs={12} sm={8}>
                      <Field
                        id="id1002KoziTitle"
                        name="KoziTitle__c"
                        component={renderTextField}
                        className={classes.fields}
                        label='工事件名'
                        type="text"
                        fullWidth
                        required={true}
                        validate={[
                          validateRule.maxLength(50),
                        ]}
                        warn={[
                          validateRule.required,
                        ]}
                        disabled={this.state.isDisabled}
                      />
                    </Grid>
                  </Grid>
                  {/* 工事 */}
                  <Typography variant="h6" gutterBottom>工事場所&nbsp;
                    <MuiTooltip
                      id="tl1002SelectDnt"
                      placement='bottom'
                      content={
                        <React.Fragment>
                        電柱を選択して保存ボタンを押すと代表電柱を次の画面の申込電柱に追加します。<br/>
                        申込電柱の中に代表電柱がない場合、次の画面の電柱選択ボタン<br/>
                        または電柱追加ボタンを使って代表電柱を申込電柱に追加してください。
                        </React.Fragment>}>
                      <InfoOutlined fontSize="small"/>
                    </MuiTooltip>
                  </Typography>
                  <Grid container
                    justifyContent="flex-start"
                    alignItems="flex-start"
                    spacing={2}
                  >
                    <Grid key="key1002KoziPlaceMainDntNoSenroName" item xs={12} sm={2}>
                      <Field
                        id="id1002KoziPlaceMainDntNoSenroName"
                        name="KoziPlaceMainDntNo_SenroName__c"
                        component={renderTextField}
                        className={classes.fields}
                        label='線路名'
                        fullWidth
                        InputProps={{
                          readOnly: true,
                        }}
                        type="text"
                        required={false}
                        validate={[
                        ]}
                        warn={[
                        ]}
                      />
                    </Grid>
                    <Grid key="key1002KoziPlaceMainDntNo" item xs={12} sm={2}>
                      <Field
                        id="id1002KoziPlaceMainDntNo"
                        name="Dsp_KoziPlaceMainDntNo__c"
                        component={renderTextField}
                        className={classes.fields}
                        label='代表電柱番号'
                        fullWidth
                        InputProps={{
                          readOnly: true,
                        }}
                        type="text"
                        required={true}
                        validate={[
                        ]}
                        warn={[
                          validateRule.required,
                        ]}
                      />
                    </Grid>
                    <Grid key="key1002SelectDnt" item xs={12} sm={8}>
                      <PositiveButton
                        id="id1002SelectDnt"
                        onClick={() => {
                          this.setState({modalOpen: true});
                        }}
                        variant="contained"
                        size="large"
                        disabled={this.state.isDisabled}
                      >
                        <span>電柱選択</span>
                      </PositiveButton>
                    </Grid>
                    <Grid key="key1002KoziPlacePrefectures" item xs={12} sm={2}>
                      <Field
                        id="id1002KoziPlacePrefectures"
                        name="KoziPlacePrefectures__c"
                        component={renderSelect}
                        className={classes.fields}
                        label='都道府県'
                        fullWidth
                        required={true}
                        InputProps={{
                          readOnly: false,
                        }}
                        validate={[
                        ]}
                        warn={[
                          validateRule.required,
                        ]}
                        disabled={this.state.isDisabled}
                      >
                        {generalPurposeMap &&
                          createSearchList(generalPurposeMap.PrefCode)}
                      </Field>
                    </Grid>
                    <Grid key="key1002KoziPlaceMunicipalities" item xs={12} sm={4}>
                      <Field
                        id="id1002KoziPlaceMunicipalities"
                        name="KoziPlaceMunicipalities__c"
                        component={renderTextField}
                        className={classes.fields}
                        label='市区町村'
                        fullWidth
                        type="text"
                        required={true}
                        InputProps={{
                          readOnly: false,
                        }}
                        validate={[
                          validateRule.maxLength(12),
                        ]}
                        warn={[
                          validateRule.required,
                        ]}
                        disabled={this.state.isDisabled}
                      />
                    </Grid>
                    <Grid key="key1002KoziPlacePlace" item xs={12} sm={4}>
                      <Field
                        id="id1002KoziPlacePlace"
                        name="KoziPlacePlace__c"
                        component={renderTextField}
                        className={classes.fields}
                        label='場所'
                        fullWidth
                        type="text"
                        required={true}
                        InputProps={{
                          readOnly: false,
                        }}
                        validate={[
                          validateRule.maxLength(255),
                        ]}
                        warn={[
                          validateRule.required,
                        ]}
                        disabled={this.state.isDisabled}
                      />
                    </Grid>
                  </Grid>
                  <Grid
                    container
                    justifyContent="flex-start"
                    alignItems="flex-start"
                    spacing={1}>
                    <Grid key="key1002StbType" item xs={12} sm={3}>
                      <Field
                        id="id1002StbType"
                        name="StbType__c"
                        component={renderSelect}
                        className={classes.fields}
                        label='設備種別'
                        fullWidth
                        required={false}
                        InputProps={{
                          readOnly: true,
                        }}
                        validate={[
                        ]}
                      >
                        {generalPurposeMap &&
                          createSearchList(generalPurposeMap.StbType, 'Code__c', 'Name', {Code__c: ['1', '2']})}
                      </Field>
                    </Grid>
                    {/* 共架種別は共架事業者によって異なる*/}
                    <Grid key="key1002KyogaType" item xs={12} sm={3}>
                      <Field
                        id="id1002KyogaType"
                        name="KyogaType__c"
                        component={renderSelect}
                        className={classes.fields}
                        label='共架種別'
                        fullWidth
                        required={true}
                        validate={[
                        ]}
                        warn={[
                          validateRule.required,
                        ]}
                        disabled={this.state.isDisabled}
                      >
                        {generalPurposeMap &&
                          createSearchList(generalPurposeMap.KyogaType,
                              'Code__c',
                              'Name',
                              {Code__c:
                                Object.hasOwnProperty.call(userInfo.Account, 'Account__r') &&
                                Object.hasOwnProperty.call(userInfo.Account.Account__r, 'KyogaType__c') ?
                                userInfo.Account.Account__r.KyogaType__c : '',
                              ValueString1__c: this.isSen ? ['1'] : ['2']})}
                      </Field>
                    </Grid>
                  </Grid>
                  <Grid
                    container
                    justifyContent="flex-start"
                    alignItems="flex-start"
                    spacing={1}
                  >
                    <Grid key="key1002ZizenNegotiationNo" item xs={12} sm={2}>
                      <Field
                        id="id1002ZizenNegotiationNo"
                        name="ZizenNegotiationNo__c"
                        component={renderTextField}
                        className={classes.fields}
                        label='協議番号'
                        type="text"
                        fullWidth
                        required={false}
                        validate={[
                          validateRule.numericHyphen,
                          validateRule.maxLength(13),
                        ]}
                        disabled={this.state.isDisabled}
                      />
                    </Grid>
                  </Grid>
                </PaperPart>
              </Grid>
              {/* 添付ファイル */}
              <Grid key="key1002AttachGrid" item xs={12} sm={7}>
                <PaperPart>
                  <Typography variant="h6" gutterBottom>添付ファイル</Typography>
                  <Grid container
                    justifyContent="flex-start"
                    alignItems="center"
                    spacing={1}
                  >
                    <Grid key="key1002PictureFile" item xs={12}>
                      <Typography variant="h6" display="block">
                        装柱図
                        <font size="2">(※最大1ファイル、1ファイルあたり20MBまで登録できます)</font>
                        <Required/>
                        <MuiTooltip content={
                          <React.Fragment>
                            電柱番号，全景，共架部分拡大写真・装柱図等の資料を添付してください。
                          </React.Fragment>
                        }>
                          <InfoOutlined/>
                        </MuiTooltip>
                      </Typography>
                    </Grid>
                    <Grid key="key1002UploadPictureFile" item xs={12}>
                      <Upload
                        componentId="pictureComponent"
                        maxFileCount={1}
                        maxFileSize={20971520}
                        required={true}
                        previewFlag={false}
                        previewWidth="35%"
                        acceptFileType=".pdf,.doc,.docx,.xls,.xlsx"
                        fileSetHandler={this.setPictureFiles}
                        initFile={this.state.pictureFiles}
                        disabled={this.state.isDisabled}
                        customChecks={[
                          checkFileNameLength,
                          checkFileSizeZero,
                          checkSameName,
                        ]}
                      />
                    </Grid>
                    <Grid key="key1002RootFile" item xs={12}>
                      {this.isSen &&
                        <Typography variant="h6" display="block">
                          ルート図
                          <font size="2">(※最大3ファイル、1ファイルあたり3MBまで登録できます)</font>
                          <Required/>
                          <MuiTooltip content={
                            <React.Fragment>
                              申込ルートが分かる資料を添付してください。
                            </React.Fragment>
                          }>
                            <InfoOutlined/>
                          </MuiTooltip>
                        </Typography>
                      }
                      {!this.isSen &&
                        <Typography variant="h6" display="block">
                          平面図
                          <font size="2">(※最大3ファイル、1ファイルあたり3MBまで登録できます)</font>
                          <Required/>
                          <MuiTooltip content={
                            <React.Fragment>
                              設置場所が分かる資料を添付してください。
                            </React.Fragment>
                          }>
                            <InfoOutlined/>
                          </MuiTooltip>
                        </Typography>
                      }
                    </Grid>
                    <Grid key="key1002UploadRootFile" item xs={12}>
                      {this.isSen &&
                        <Upload
                          componentId="rootComponent"
                          maxFileCount={3}
                          maxFileSize={3145728}
                          required={true}
                          previewFlag={true}
                          previewWidth="35%"
                          acceptFileType=".pdf,.doc,.docx,.xls,.xlsx"
                          fileSetHandler={this.setRootFiles}
                          initFile={this.state.rootFiles}
                          disabled={this.state.isDisabled}
                          customChecks={[
                            checkFileNameLength,
                            checkFileSizeZero,
                            checkSameName,
                          ]}
                        />
                      }
                      {!this.isSen &&
                        <Upload
                          componentId="horizonComponent"
                          maxFileCount={3}
                          maxFileSize={3145728}
                          required={true}
                          previewFlag={true}
                          previewWidth="35%"
                          acceptFileType=".pdf,.doc,.docx,.xls,.xlsx"
                          fileSetHandler={this.setHorizonFiles}
                          initFile={this.state.horizonFiles}
                          disabled={this.state.isDisabled}
                          customChecks={[
                            checkFileNameLength,
                            checkFileSizeZero,
                            checkSameName,
                          ]}
                        />
                      }
                    </Grid>
                    <Grid key="key1002SpecFile" item xs={12}>
                      <Typography variant="h6" display="block">
                        共架設備仕様書
                        <font size="2">(※最大3ファイル、1ファイルあたり3MBまで登録できます)</font>
                        <Required/>
                        <MuiTooltip content={
                          <React.Fragment>
                            ・共架の対象および共架伝送路設備の資料<br/>
                            ・共架伝送路設備の諸元表<br/>
                            　を添付してください。
                          </React.Fragment>
                        }>
                          <InfoOutlined/>
                        </MuiTooltip>
                      </Typography>
                    </Grid>
                    <Grid key="key1002UploadSpecFile" item xs={12}>
                      <Upload
                        componentId="specComponent"
                        maxFileCount={3}
                        maxFileSize={3145728}
                        required={true}
                        previewFlag={true}
                        previewWidth="35%"
                        acceptFileType=".pdf,.doc,.docx,.xls,.xlsx"
                        fileSetHandler={this.setSpecFiles}
                        initFile={this.state.specFiles}
                        disabled={this.state.isDisabled}
                        customChecks={[
                          checkFileNameLength,
                          checkFileSizeZero,
                          checkSameName,
                        ]}
                      />
                    </Grid>
                    <Grid key="key1002OtherFile" item xs={12}>
                      <Typography variant="h6" display="block">
                        その他資料
                        <font size="2">(※最大3ファイル、1ファイルあたり3MBまで登録できます)</font>
                        <MuiTooltip content={
                          <React.Fragment>
                            上記以外の資料を添付してください。
                          </React.Fragment>
                        }>
                          <InfoOutlined/>
                        </MuiTooltip>
                      </Typography>
                    </Grid>
                    <Grid key="key1002UploadOtherFile" item xs={12}>
                      <Upload
                        componentId="otherComponent"
                        maxFileCount={3}
                        maxFileSize={3145728}
                        required={false}
                        previewFlag={true}
                        previewWidth="35%"
                        acceptFileType=".pdf,.doc,.docx,.xls,.xlsx"
                        fileSetHandler={this.setOtherFiles}
                        initFile={this.state.otherFiles}
                        disabled={this.state.isDisabled}
                        customChecks={[
                          checkFileNameLength,
                          checkFileSizeZero,
                          checkSameName,
                        ]}
                      />
                    </Grid>
                  </Grid>
                </PaperPart>
              </Grid>
              {/* その他 */}
              <Grid key="key1002OOtherGrid" item xs={12} sm={5}>
                <PaperPart>
                  <Grid container
                    justifyContent="flex-start"
                    alignItems="flex-start"
                    spacing={1}
                  >
                    <Grid key="key1002Memo" item xs={12}>
                      <Field
                        id="id1002Memo"
                        name="MemoContents__c"
                        component={renderTextField}
                        className={classes.fields}
                        label='メモ内容'
                        variant="outlined"
                        type="text"
                        multiline
                        rows={20}
                        fullWidth
                        required={false}
                        validate={[
                          validateRule.maxLength(255),
                        ]}
                        disabled={this.state.isDisabled}
                      />
                    </Grid>
                  </Grid>
                </PaperPart>
              </Grid>
            </Grid>
          </MainContainer>
          <SelectPoleNo
            YbdsType="A"
            modalOpen={this.state.modalOpen}
            closeButton={this.closeSelectDnt}
            setSelectedPole={this.setSelectedDnt}/>
        </form>
      </>
    );
  }
}

Container.propTypes = {
  classes: PropTypes.object,
  generalPurposeMap: PropTypes.object,
  order: PropTypes.object,
  history: PropTypes.object,
  stbType: PropTypes.object,
  values: PropTypes.object,
  userInfo: PropTypes.object,
  syncWarnings: PropTypes.object,
  handleSubmit: PropTypes.func,
  change: PropTypes.func,
  doShowMessage: PropTypes.func,
  doGetOrderInfo: PropTypes.func,
  doSetOrderId: PropTypes.func,
  orderId: PropTypes.string,
  orderResult: PropTypes.object,
  KyogasyaSendBackReason__c: PropTypes.string,
  OrderKyogaZgsyaName: PropTypes.string,
  KoziTitle__c: PropTypes.string,
  KoziPlaceMainDntNo__c: PropTypes.string,
  KoziPlacePrefectures__c: PropTypes.string,
  KoziPlaceMunicipalities__c: PropTypes.string,
  KoziPlacePlace__c: PropTypes.string,
  StbType__c: PropTypes.string,
  KyogaType__c: PropTypes.string,
  ZizenNegotiationNo__c: PropTypes.string,
  MemoContents__c: PropTypes.string,
  rootFiles: PropTypes.array,
  horizonFiles: PropTypes.array,
  specFiles: PropTypes.array,
  otherFiles: PropTypes.array,
  deleteFiles: PropTypes.array,
  dirty: PropTypes.bool,
  contentDocuments: PropTypes.array,
  doSaveProprietyOrder: PropTypes.func,
  doClearOrderInfo: PropTypes.func,
  doSetGmnWarning: PropTypes.func,
  setGmnWarning: PropTypes.object,
  doSetOrderModifiedCondition: PropTypes.func,
  orderModifiedCondition: PropTypes.object,
};

const mapStateToProps = (state) => {
  const initValues = {
    OrderNo__c: null,
    TemporarilySavedDate__c: null,
    ProprietyJudgeOrderDate__c: null,
    KyogasyaSendBackReason__c: null,
    OrderKyogaZgsya__c: state.auth.userInfo.AccountId,
    OrderKyogaZgsyaName: state.auth.userInfo.Account.Name,
    KoziTitle__c: null,
    MainDntNoNWZgsyo__c: null,
    Dsp_KoziPlaceMainDntNo__c: null,
    KoziPlaceMainDntNo_SenroCode__c: null,
    KoziPlaceMainDntNo_SenroName__c: null,
    KoziPlaceMainDntNo__c: null,
    KoziPlacePrefectures__c: null,
    KoziPlaceMunicipalities__c: null,
    KoziPlacePlace__c: null,
    StbType__c: state.common.stbType,
    KyogaType__c: null,
    ZizenNegotiationNo__c: null,
    MemoContents__c: null,
  };

  const order = state.attachorder.orderInfo &&
                Object.hasOwnProperty.call(state.attachorder.orderInfo, 'order') ?
                state.attachorder.orderInfo.order : [];
  for (const key in order) {
    if (Object.hasOwnProperty.call(order, key)) {
      if (order[key]) {
        if (key == 'TemporarilySavedDate__c') {
          initValues[key] = changeDateFormatter(order[key], 'YYYY-MM-DD');
        } else if (key == 'OrderKyogaZgsya__r') {
          initValues['OrderKyogaZgsyaName'] =
            Object.hasOwnProperty.call(order[key], 'Name') ? order[key].Name : '' +
            Object.hasOwnProperty.call(order[key], 'Account__r') &&
            Object.hasOwnProperty.call(order[key].Account__r, 'Name') ?
            order[key].Account__r.Name: '';
        } else {
          initValues[key] = order[key];
        }
      }
    }
  }

  return {
    generalPurposeMap: state.common.generalPurposeMap,
    userInfo: state.auth.userInfo,
    orderId: state.attachorder.orderId,
    order: order,
    contentDocuments: state.attachorder.orderInfo &&
        Object.hasOwnProperty.call(state.attachorder.orderInfo, 'contentDocuments') ?
          state.attachorder.orderInfo.contentDocuments : [],
    orderResult: state.attachorder.orderResult,
    stbType: state.common.stbType,
    setGmnWarning: state.common.setGmnWarning,
    orderModifiedCondition: state.attachorder.orderModifiedCondition,
    initialValues: initValues,
  };
};

const mapDispatchToProps = {
  doShowMessage: commonOperations.doShowMessage,
  getUserInfo: authOperations.getUserInfoOperation,
  doSetOrderId: attachorderOperations.doSetOrderId,
  doGetOrderInfo: attachorderOperations.doGetOrderInfo,
  doSaveProprietyOrder:
    attachorderOperations.doSaveProprietyOrder,
  doClearOrderInfo: attachorderOperations.doClearOrderInfo,
  doSetGmnWarning: commonOperations.doSetGmnWarning,
  doSetOrderModifiedCondition:
    attachorderOperations.doSetOrderModifiedCondition,
};

const FORM_NAME = 'ProprietyBasicInfo';

Container = reduxForm({
  form: FORM_NAME,
  destroyOnUnmount: false,
  enableReinitialize: true,
})(connect((state) => {
  return {
    values: getFormValues(FORM_NAME)(state),
    syncWarnings: getFormSyncWarnings(FORM_NAME)(state),
  };
})(Container));

export default withStyles(styles)(
    connect(
        mapStateToProps,
        mapDispatchToProps,
    )(Container),
);
